import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative min-h-screen bg-white dark:bg-[#0c1427]/95" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "sm:flex sm:items-center sm:justify-between" }
const _hoisted_5 = { class: "text-2xl font-bold text-gray-900 dark:text-gray-100" }
const _hoisted_6 = { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_7 = { class: "mt-4 sm:mt-0 flex items-center justify-between sm:justify-start sm:gap-3" }
const _hoisted_8 = {
  href: "/documentation",
  target: "_blank",
  class: "inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 cursor-pointer"
}
const _hoisted_9 = { class: "hidden sm:inline" }
const _hoisted_10 = { class: "sm:hidden" }
const _hoisted_11 = { class: "hidden sm:inline" }
const _hoisted_12 = { class: "sm:hidden" }
const _hoisted_13 = { class: "bg-white dark:bg-[#15203c] shadow-sm rounded-lg border border-gray-200 dark:border-gray-700" }
const _hoisted_14 = { class: "px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_15 = { class: "text-lg font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_16 = { class: "hidden sm:block overflow-x-auto" }
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_18 = { class: "bg-white dark:bg-[#15203c] border-b border-gray-100 dark:border-gray-700" }
const _hoisted_19 = { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" }
const _hoisted_20 = { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" }
const _hoisted_21 = { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" }
const _hoisted_22 = { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" }
const _hoisted_23 = { class: "bg-white dark:bg-[#15203c] divide-y divide-gray-100 dark:divide-gray-700" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  colspan: "4",
  class: "px-4 py-6 text-center text-gray-500 dark:text-gray-400"
}
const _hoisted_26 = { class: "flex items-center justify-center" }
const _hoisted_27 = { class: "px-4 py-3 whitespace-nowrap" }
const _hoisted_28 = { class: "flex items-center justify-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_31 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_32 = { class: "px-4 py-3 whitespace-nowrap text-center" }
const _hoisted_33 = { class: "inline-block text-sm font-mono text-gray-900 dark:text-gray-100 bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded" }
const _hoisted_34 = { class: "px-4 py-3 whitespace-nowrap text-center text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_35 = { class: "px-4 py-3 whitespace-nowrap text-center" }
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  colspan: "4",
  class: "px-4 py-6 text-center text-gray-500 dark:text-gray-400"
}
const _hoisted_39 = { class: "sm:hidden space-y-4 p-4" }
const _hoisted_40 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_41 = { class: "flex items-center justify-center" }
const _hoisted_42 = { class: "flex items-start justify-between" }
const _hoisted_43 = { class: "flex items-start space-x-3" }
const _hoisted_44 = { class: "flex-1 min-w-0" }
const _hoisted_45 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100 truncate" }
const _hoisted_46 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-1" }
const _hoisted_47 = { class: "text-xs font-mono text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded mt-2 inline-block" }
const _hoisted_48 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-2" }
const _hoisted_49 = ["onClick", "title"]
const _hoisted_50 = {
  key: 0,
  class: "text-center py-8 text-gray-500 dark:text-gray-400"
}
const _hoisted_51 = {
  key: 0,
  class: "hidden sm:block px-4 py-3 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-[#15203c]"
}
const _hoisted_52 = { class: "flex items-center justify-between" }
const _hoisted_53 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_54 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_55 = {
  key: 1,
  class: "sm:hidden px-4 py-3 bg-white dark:bg-[#15203c] border-t border-gray-200 dark:border-gray-700 rounded-b-lg"
}
const _hoisted_56 = { class: "text-center space-y-2" }
const _hoisted_57 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_58 = { class: "text-xs text-gray-500 dark:text-gray-400 flex items-center justify-center" }
const _hoisted_59 = { class: "mt-8 bg-white dark:bg-[#15203c] border border-gray-200 dark:border-gray-700 rounded-lg p-6 shadow-sm" }
const _hoisted_60 = { class: "flex items-start" }
const _hoisted_61 = { class: "ltr:ml-3 rtl:mr-3" }
const _hoisted_62 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_63 = { class: "mt-2 text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_64 = { class: "mt-3" }
const _hoisted_65 = {
  href: "/documentation",
  target: "_blank",
  class: "inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 cursor-pointer"
}
const _hoisted_66 = { class: "bg-white dark:bg-[#15203c] rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-lg w-full max-h-screen overflow-y-auto" }
const _hoisted_67 = { class: "px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_68 = { class: "flex items-center justify-between" }
const _hoisted_69 = { class: "flex items-center space-x-3" }
const _hoisted_70 = { class: "text-xl font-semibold text-gray-900 dark:text-gray-100" }
const _hoisted_71 = { class: "px-6 py-6" }
const _hoisted_72 = { class: "mb-6" }
const _hoisted_73 = { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3" }
const _hoisted_74 = { class: "relative" }
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_77 = { class: "px-6 py-4 bg-white dark:bg-[#15203c]/50 border-t border-gray-200 dark:border-gray-700 rounded-b-xl" }
const _hoisted_78 = { class: "flex justify-between items-center" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_81 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_82 = {
  key: 1,
  class: "modal"
}
const _hoisted_83 = { class: "bg-white dark:bg-[#15203c] rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-lg w-full max-h-screen overflow-y-auto" }
const _hoisted_84 = { class: "px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_85 = { class: "flex items-center space-x-3" }
const _hoisted_86 = { class: "text-xl font-semibold text-gray-900 dark:text-gray-100" }
const _hoisted_87 = { class: "px-6 py-6" }
const _hoisted_88 = { class: "bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 mb-6" }
const _hoisted_89 = { class: "flex items-start" }
const _hoisted_90 = { class: "ltr:ml-3 rtl:mr-3" }
const _hoisted_91 = { class: "text-sm font-semibold text-orange-800 dark:text-orange-200 mb-1" }
const _hoisted_92 = { class: "text-sm text-orange-700 dark:text-orange-300" }
const _hoisted_93 = { class: "mb-6" }
const _hoisted_94 = { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3" }
const _hoisted_95 = { class: "relative" }
const _hoisted_96 = ["value"]
const _hoisted_97 = ["title"]
const _hoisted_98 = { class: "flex items-center space-x-1" }
const _hoisted_99 = {
  key: 0,
  class: "text-xs text-green-600 dark:text-green-400"
}
const _hoisted_100 = { class: "px-6 py-4 bg-gray-50 dark:bg-[#15203c]/50 border-t border-gray-200 dark:border-gray-700 rounded-b-xl" }
const _hoisted_101 = { class: "flex justify-end" }
const _hoisted_102 = { class: "bg-white dark:bg-[#15203c] rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-md w-full max-h-screen overflow-y-auto" }
const _hoisted_103 = { class: "p-6" }
const _hoisted_104 = { class: "text-lg font-semibold mb-4" }
const _hoisted_105 = { class: "text-gray-600 dark:text-gray-400 mb-6" }
const _hoisted_106 = { class: "flex justify-between items-center" }
const _hoisted_107 = ["disabled"]
const _hoisted_108 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_109 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('apiSettings.title')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('apiSettings.description')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-book-open-line ltr:mr-2 rtl:ml-2" }, null, -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('apiSettings.viewDocumentation')), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('apiSettings.documentation')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateModal = true)),
                class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "ri-add-line ltr:mr-2 rtl:ml-2" }, null, -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('apiSettings.createNewApiKey')), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.create')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('apiSettings.yourApiKeys')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", _hoisted_18, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('apiSettings.name')), 1),
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('apiSettings.last4Digits')), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('apiSettings.creationDate')), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('apiSettings.actions')), 1)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_23, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[13] || (_cache[13] = _createElementVNode("svg", {
                            class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')) + "... ", 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiKeys, (key, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: key.id,
                          class: "hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ltr:mr-3 rtl:ml-3", _ctx.getKeyIconClass(index)])
                              }, _cache[14] || (_cache[14] = [
                                _createElementVNode("i", { class: "ri-key-line text-sm" }, null, -1)
                              ]), 2),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, _toDisplayString(key.name), 1),
                                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('apiSettings.apiKeyDescription')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, " •••• " + _toDisplayString(key.last_chars), 1)
                          ]),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.formatDate(key.created_at)), 1),
                          _createElementVNode("td", _hoisted_35, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.confirmDelete(key)),
                              class: "text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 p-2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors",
                              title: _ctx.$t('common.delete')
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                            ]), 8, _hoisted_36)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.apiKeys.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                            _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.$t('apiSettings.noApiKeys')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[16] || (_cache[16] = _createElementVNode("svg", {
                      class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')) + "... ", 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiKeys, (key, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key.id,
                      class: "bg-white dark:bg-[#15203c] border border-gray-200 dark:border-gray-700 rounded-lg p-4 shadow-sm"
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center", _ctx.getKeyIconClass(index)])
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "ri-key-line text-lg" }, null, -1)
                          ]), 2),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, _toDisplayString(key.name), 1),
                            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('apiSettings.apiKeyDescription')), 1),
                            _createElementVNode("div", _hoisted_47, " •••• " + _toDisplayString(key.last_chars), 1),
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDate(key.created_at)), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.confirmDelete(key)),
                          class: "text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 p-2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors",
                          title: _ctx.$t('common.delete')
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "ri-delete-bin-line text-lg" }, null, -1)
                        ]), 8, _hoisted_49)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.apiKeys.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.$t('apiSettings.noApiKeys')), 1))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          (_ctx.apiKeys.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('apiSettings.showingApiKeys', { count: _ctx.apiKeys.length })), 1),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "ri-information-line ltr:mr-1 rtl:ml-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('apiSettings.securityWarning')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.apiKeys.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('apiSettings.showingApiKeys', { count: _ctx.apiKeys.length })), 1),
                  _createElementVNode("div", _hoisted_58, [
                    _cache[20] || (_cache[20] = _createElementVNode("i", { class: "ri-information-line ltr:mr-1 rtl:ml-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('apiSettings.securityWarning')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", { class: "ri-lightbulb-line text-blue-600 dark:text-blue-400 text-lg" })
            ], -1)),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h3", _hoisted_62, _toDisplayString(_ctx.$t('apiSettings.needHelp')), 1),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('apiSettings.helpDescription')), 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("a", _hoisted_65, [
                  _cache[21] || (_cache[21] = _createElementVNode("i", { class: "ri-external-link-line ltr:mr-1 rtl:ml-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('apiSettings.readApiDocumentation')), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showCreateModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showCreateModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "w-8 h-8 bg-blue-100 dark:bg-blue-900/20 rounded-lg flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "ri-key-line text-blue-600 dark:text-blue-400" })
                  ], -1)),
                  _createElementVNode("h3", _hoisted_70, _toDisplayString(_ctx.$t('apiSettings.createNewApiKey')), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateModal = false)),
                  class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                }, _cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "ri-close-line text-xl" }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('apiSettings.keyName')), 1),
                _createElementVNode("div", _hoisted_74, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newKeyName) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-100 text-sm transition-colors",
                    placeholder: _ctx.$t('apiSettings.keyNamePlaceholder')
                  }, null, 8, _hoisted_75), [
                    [_vModelText, _ctx.newKeyName]
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" }, [
                    _createElementVNode("i", { class: "ri-edit-line text-gray-400" })
                  ], -1))
                ]),
                _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t('apiSettings.keyNameHelper')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCreateModal = false)),
                  class: "px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg transition-colors"
                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createApiKey && _ctx.createApiKey(...args))),
                  disabled: !_ctx.newKeyName.trim() || _ctx.loading,
                  class: "px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-400 disabled:cursor-not-allowed rounded-lg shadow-sm transition-colors flex items-center"
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                        _cache[26] || (_cache[26] = _createElementVNode("svg", {
                          class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_81, [
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "ri-add-line ltr:mr-2 rtl:ml-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.create')), 1)
                      ]))
                ], 8, _hoisted_79)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showKeyModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "w-8 h-8 bg-green-100 dark:bg-green-900/20 rounded-lg flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "ri-check-line text-green-600 dark:text-green-400" })
                ], -1)),
                _createElementVNode("h3", _hoisted_86, _toDisplayString(_ctx.$t('apiSettings.apiKeyCreated')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("i", { class: "ri-alert-line text-orange-600 dark:text-orange-400 text-lg" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("h4", _hoisted_91, _toDisplayString(_ctx.$t('apiSettings.important')), 1),
                    _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.$t('apiSettings.saveKeyWarning')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('apiSettings.yourNewApiKey')), 1),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("input", {
                    value: _ctx.generatedKey,
                    type: "text",
                    readonly: "",
                    class: "w-full px-4 py-3 pr-12 font-mono text-sm bg-gray-50 dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-gray-100 select-all"
                  }, null, 8, _hoisted_96),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.copyKey && _ctx.copyKey(...args))),
                    class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors",
                    title: _ctx.$t('common.copy')
                  }, [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.copied ? 'ri-check-line text-green-600 dark:text-green-400' : 'ri-file-copy-line')
                      }, null, 2),
                      (_ctx.copied)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_ctx.$t('common.copied')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_97)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeKeyModal && _ctx.closeKeyModal(...args))),
                  class: "px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors flex items-center"
                }, [
                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "ri-check-line ltr:mr-2 rtl:ml-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.done')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showDeleteModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("h3", _hoisted_104, _toDisplayString(_ctx.$t('apiSettings.deleteConfirmTitle')), 1),
              _createElementVNode("p", _hoisted_105, _toDisplayString(_ctx.$t('apiSettings.deleteConfirmMessage', { name: _ctx.keyToDelete?.name })), 1),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteModal = false)),
                  class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteApiKey && _ctx.deleteApiKey(...args))),
                  disabled: _ctx.loading,
                  class: "px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed rounded-lg transition-colors"
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                        _cache[31] || (_cache[31] = _createElementVNode("svg", {
                          class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(_ctx.$t('common.delete')), 1))
                ], 8, _hoisted_107)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}